<aup-place-outlet [placeAnimationOrder]="childPlaces" [animate]="false"></aup-place-outlet>
